export const GENERIC_ERROR_MESSAGE =
  'Houve um problema ao realizar o pagamento, por favor verifique os dados do cartão';

export default GENERIC_ERROR_MESSAGE;
